  <template>
  <div class="wrapper df fdc jcc aic jcsb"> <!-- Temporary: removed 'df fdc jcc aic jcsb' classes/-->
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage">
    </loading>
    <PopupShare
      v-bind:closePopup="closePopup"
      v-if="$store.getters.globalPopup && ($store.getters.popupProject == this.$route.params.projectid)"
    />
    <div v-on:click="closePopup()" v-if="$store.getters.globalPopup && ($store.getters.popupDeleteProject)" class="global-popup">
      <div class="box global-popup-inner global-popup-inner-delete df fdc" v-on:click="stopProp($event)">
        <div class="popup-top df">
          <img src="/images/warning-icon.png" alt="">
          <div class=f1>
            <p class="popup-title gg-font">Delete Project</p>
            <p class="popup-text gg-font">This is a permanent action and cannot be undone.</p>
          </div>
        </div>
        <div class="popup-bottom">
          <p class="popup-text gg-font popup-sub-heading">
            When you delete a project, this immediately happens:
          </p>
          <p class="popup-text gg-font popup-point">
            All contents of your project are erased
          </p>
          <p class="popup-text gg-font popup-point">
            You lose access to your entire project
          </p>
          <span class="buttons df jcfe">
            <button class="popup-reject-button gg-font" @click="closePopup()">
              Cancel
            </button>
            <button class="popup-accept-button gg-font" @click="deleteProject($store.getters.popupDeleteProject)">
              Yes, delete project
            </button>
          </span>
        </div>
      </div>
    </div>

    <div v-on:click="closePopup()" v-if="$store.getters.globalPopup && $store.getters.popupTooManyProjects" class="global-popup">
      <div class="box global-popup-inner global-popup-inner-delete df fdc" v-on:click="stopProp($event)">
        <div class="popup-top df">
          <img src="/images/warning-icon.png" alt="">
          <div class=f1>
            <p class="popup-title gg-font">Unable to Create Project</p>
            <p class="popup-text gg-font">You've reached the limit of projects for your plan.</p>
          </div>
        </div>
        <div class="popup-bottom">
          <p class="popup-text gg-font popup-sub-heading">
            Please upgrade to create more projects.
          </p>
          <span class="buttons df jcfe">
            <button class="popup-accept-button gg-font" @click="closePopup()">
              Ok
            </button>
          </span>
        </div>
      </div>
    </div>

    <!-- export popup -->
    <div v-on:click="closePopup()" v-if="$store.getters.globalPopup && $store.getters.popupExportProjectData" class="global-popup">
      <div class="box global-popup-inner global-popup-inner-delete df fdc" v-on:click="stopProp($event)">
        <div class="popup-top df">
          <img src="/images/warning-icon.png" alt="">
          <div class=f1>
            <p class="popup-title gg-font">Export data</p>
            <p class="popup-text gg-font">Download your project data</p>
          </div>
        </div>
        <div class="popup-bottom">
          <p class="popup-text gg-font popup-sub-heading">
            Select Format
          </p>
          <span class="buttons df jcfe">
            <button class="popup-accept-button gg-font" @click="doExport()">
              CSV
            </button>
          </span>
        </div>
      </div>
    </div>

    <AuthWrapper>

      <DashboardHeader  v-bind:dashboardPage="dashboardPage"
                        v-bind:headerMode="headerMode"
                        />
      <DashboardHome v-if="dashboardPage == 'home'"/>
      <DashboardExplore v-else-if="dashboardPage == 'explore'"/>
      <DashboardProjects
        v-bind:myProjectDetailsList="myProjectDetailsList"
        v-bind:myProjectDetailsListFull="myProjectDetailsListFull"
        v-else-if="dashboardPage == 'project'"/>
      <DashboardProject
        v-bind:myProjectDetailsList="myProjectDetailsList"
        v-bind:projectPage="'pricing'"
        v-else-if="dashboardPage == 'project-pricing'"/>
      <DashboardProject
        v-bind:myProjectDetailsList="myProjectDetailsList"
        v-bind:projectPage="'tasks'"
        v-else-if="dashboardPage == 'project-tasks'"/>
      <DashboardProject
        v-bind:myProjectDetailsList="myProjectDetailsList"
        v-bind:projectPage="'totals'"
        v-else-if="dashboardPage == 'project-totals'"/>
      <DashboardProject
        v-bind:myProjectDetailsList="myProjectDetailsList"
        v-bind:projectPage="'phases'"
        v-else-if="dashboardPage == 'project-phases'"/>
      <DashboardTasks v-else-if="dashboardPage == 'tasks'"/>
      <DashboardPeople v-else-if="dashboardPage == 'people'"/>
      <DashboardCompany v-else-if="(dashboardPage == 'company') && (subPage == 'company')"/>
      <DashboardChangePlan v-else-if="(dashboardPage == 'company') && (subPage == 'changePlan')" v-bind:planPage="planPage"/>
      <DashboardPricing v-else-if="(dashboardPage == 'company') && (subPage == 'pricing')"/>
      <DashboardProfile v-else-if="dashboardPage == 'profile'"/>
      <DashboardBilling v-else-if="dashboardPage == 'billing'"/>

    </AuthWrapper>

  </div>
</template>

<script>
import Popup from '@/components/popups/Popup'
import DashboardHeader from '@/components/dashboard/DashboardHeader'
import DashboardHome from '@/components/dashboard/DashboardHome'
import DashboardExplore from '@/components/dashboard/DashboardExplore'
import DashboardProjects from '@/components/dashboard/DashboardProjects'
import DashboardProject from '@/components/dashboard/DashboardProject'
import DashboardTasks from '@/components/dashboard/DashboardTasks'
import DashboardPeople from '@/components/dashboard/DashboardPeople'
import DashboardCompany from '@/components/dashboard/DashboardCompany'
import DashboardChangePlan from '@/components/dashboard/DashboardChangePlan'
import DashboardPricing from '@/components/dashboard/DashboardPricing'
import DashboardProfile from '@/components/dashboard/DashboardProfile'
import DashboardBilling from '@/components/dashboard/DashboardBilling'
import AuthWrapper from '@/components/auth/AuthWrapper'
import PopupShare from '@/components/popups/PopupShare'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';

const axios = require('axios')

export default {
  name: 'Dashboard',
  data () {
    return {
      fullPage: true,
      changesMade: false,
      emails: '',
      comments: '',
      shareType: 'view',
      shareEmails: '',
      myProjectDetailsList: {},
      myProjectDetailsListFull: {}
    }
  },
  props: ['dashboardPage', 'headerMode', 'subPage', 'planPage'],
  components: {
    Loading,
    DashboardHeader,
    DashboardHome,
    DashboardExplore,
    DashboardProjects,
    DashboardProject,
    DashboardTasks,
    DashboardPeople,
    DashboardCompany,
    DashboardChangePlan,
    DashboardProfile,
    DashboardBilling,
    DashboardPricing,
    AuthWrapper,
    PopupShare
  },
  methods: {
    exportPrices () {
      var data = {
        columns: {...this.$store.getters.currentProjectModuleColumns},
        modules: [...this.$store.getters.currentProjectModules]
      }
      axios({
          method: 'POST',
          url: '/exportprices',
          data: data,
          headers: {
              'Content-Type': 'application/json'
          }
      })
      .then(function (response) {
        // console.log('response', response);
        console.log('RESPONSE 1', response.data.downloadurl)
        var link = document.createElement("a");
        link.download = 'PricingData';
        link.href = response.data.downloadurl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        console.log('ERROR 1', error.response);
      })
      .then(function () {
        // always executed
      });
    },
    doExport () {
      this.exportPrices()
      this.$store.dispatch('showGlobalPopup', {show: true})
      this.$store.dispatch('popupExportProjectData', {show: false})
      this.closePopup()
    },
    setShareType (type) {
      this.shareType = type
      this.makeChanges(true)
    },
    stopProp (e) {
      e.stopPropagation()
    },
    makeChanges (changesMade) {
      this.changesMade = changesMade
    },
    doShare () {
      console.log('do share...')
      if (this.validateShareProject()) {
        console.log('doShare', window.location)
        var data = {
          projectid: this.$route.params.projectid,
          emails: this.validateShareProject(),
          message: this.comments,
          url: window.location,
          shareType: this.shareType
        }
        this.$store.dispatch('doShare', data).then(() => {
          console.log('after doShare')
          this.closePopup()
        })
      }
    },
    validateShareProject () {
      var emails = this.shareEmails.split(',')
      emails = emails.map(v => v.trim())
      emails = emails.filter(v => v !== '')
      emails = emails.filter(v => this.validateEmail(v))

      if (emails.length > 0) {
        return emails
      }
      return false
    },
    validateEmail(email) {
      console.log('validating this email', email)
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    deleteProject (id) {
        this.$store.dispatch('deleteProject', {
            projectID: id,
            userID: this.$store.getters.uid
        }).then(() => {
          this.closePopup()
        })
    },
    closePopup () {
      this.changesMade = false
      this.emails = ''
      this.comments = ''
      this.shareType = 'view'

      var data = {
        projectid: ''
      }
      console.log('startShareProject')
        this.$store.dispatch('startShareProject', data)
        this.$store.dispatch('showGlobalPopup', {show: false})
        this.$store.dispatch('popupExportProjectData', {show: false})
        this.$store.dispatch('hideTooManyProjectsDialog', {})
        this.$store.dispatch('showDeleteProjectPopup', {projectID: false})
    }
  },
  computed: {
    ...mapGetters(['isLoading'])
  },
  watch: {
  },
  mounted () {
  },
  created () {
    console.log('==>', this.$route);
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetails
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
        case 'REMOVE_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
      }
    })
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetailsFull
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT_FULL':
          setTimeout(() => {
            this.myProjectDetailsListFull = this.$store.getters.myProjectListWithDetailsFull
          }, 100)
          break
      }
    })
  }
}
</script>

<style scoped lang="scss">
  h3 {
    font-size: 24px;
    font-weight: 300;
    padding-bottom: 30px;
    padding-top: 50px;
    text-align: center;
  }
  .wrapper {
    width: 100%;
    max-width: 1280px;
    min-height: 100vh;
    /*overflow-x: hidden;*/
  }


  //
  // Global Popup
  //
  .global-popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.7);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  //
  // Global Popup Inner
  //
  .global-popup-inner {
    width: 100%;
    position: fixed;

    .popup-top {
      background-color: #F5F5F5;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      padding: 24px 44px;

      img {
        object-fit: contain;
      }

      & > div {
        margin-left: 16px;
      }
    }
    .popup-bottom {
      padding: 20px 44px 24px;
    }
    .popup-title {
      font-weight: 500;
      color: #313131;
      font-size: 24px;
    }
    .popup-text {
      color: #313131;
      font-size: 16px;
    }
    .popup-sub-heading {
      font-weight: 500;
      padding-bottom: 6px;
    }
    .popup-point {
      padding-left: 20px;

      &::before {
        content: '•';
        margin-right: 6px;
      }
    }
    .popup-accept-button {
      min-width: 80px;
      padding: 10px 12px;
      border-radius: 5px;
      background-color: #5558FF;
      border: none;
      color: white;
      font-weight: 500;
      font-size: 16px;
      margin-left: 16px;
      cursor: pointer;

      &:hover {
        background-color: darken(#5558FF, 5%);
      }
    }
    .popup-reject-button {
      min-width: 80px;
      padding: 10px 12px;
      border-radius: 5px;
      background-color: #F5F5F5;
      border: none;
      color: #313131;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;

      &:hover {
        background-color: darken(#F5F5F5, 5%);
      }
    }
    .buttons {
      margin-top: 24px;
      padding-top: 8.5px;
      padding-bottom: 8.5px;
    }

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      width: auto;
      margin-left: 20px;
      margin-right: 20px;

      // popup title
      .popup-title {
        font-size: 16px;
      }

      // popup text
      .popup-text {
        font-size: 12px;
      }

      // button
      button {
        font-size: 12px !important;
      }
    }
  }


  //
  // Global Popup Inner Delete
  //
  .global-popup-inner-delete {
    max-width: 600px;
  }


  .input-wrapper {
    & > p {
      padding-bottom: 5px;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.02em;

      & > span {
        margin-left: 4px;
        font-size: 90%;
        font-weight: 300;
        color: #888888;
      }
    }
  }
  .full-blue {
    margin-top: 18px;
    margin-bottom: 6px;
  }
  .share-select, .share-selected {
    min-width: 120px;
    padding: 20px;
    margin-left: 12px;

    &:first-child {
      margin-left: 0;
    }
  }
  .share-select {
    color: #666;
    background-color: #eee;
    box-shadow: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }
  .share-selected {
    color: #5558FF;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
  }
  .comments {
    margin-bottom: 20px;
    margin-top: 20px;
    border: none;
    padding: 20px;
    background-color: #eee;
    box-shadow: none;
    font-size: 16px;
    width: 100%;
  }
  .button-form {
    margin-bottom: 20px;
  }
  .cancel {
    position: absolute;
    top: 0;
    left: 30px;
  }
  .get-link {
    position: absolute;
    top: 0;
    right: 30px;
  }
  .ok-button {
    margin-top: 20px;
  }
</style>
